export const DrawerDefaultProps = {};

export const DrawerPropTypes = {};
